import { Buffer } from 'buffer';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router, preloadCriticalPages } from '@/src/routes';

// 浏览器环境 polyfill：Node 的 Buffer 在 Vite 下未定义，部分依赖会用到
const g = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {});
(g as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;

// 全局错误处理：捕获动态导入失败等错误
if (typeof window !== 'undefined') {
  // 捕获未处理的 Promise rejection（包括动态导入失败）
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    // 检查是否是动态导入失败
    if (error && typeof error === 'object' && 'message' in error) {
      const message = String(error.message || '');
      if (message.includes('Failed to fetch dynamically imported module') || 
          message.includes('Failed to fetch') ||
          message.includes('Loading chunk') ||
          message.includes('ChunkLoadError')) {
        console.error('动态模块加载失败:', error);
        // 尝试刷新页面（清除缓存）
        const lastReload = sessionStorage.getItem('last_chunk_reload');
        const now = Date.now();
        if (!lastReload || now - parseInt(lastReload) > 3000) {
          sessionStorage.setItem('last_chunk_reload', now.toString());
          console.log('尝试刷新页面以清除缓存...');
          window.location.reload();
        } else {
          // 如果最近刚刷新过，阻止默认行为并显示错误
          event.preventDefault();
        }
      }
    }
  });

  // 捕获未处理的错误
  window.addEventListener('error', (event) => {
    const error = event.error;
    if (error && typeof error === 'object' && 'message' in error) {
      const message = String(error.message || '');
      if (message.includes('Failed to fetch dynamically imported module') ||
          message.includes('ChunkLoadError')) {
        console.error('模块加载错误:', error);
      }
    }
  });
}

// 应用启动后立即预加载关键页面（PageContent、LivePage、LiveDetailPage）
// 这些页面对性能要求高，提前预加载可以确保用户访问时已经加载完成
if (typeof window !== 'undefined') {
  // 在下一个事件循环中开始预加载，不阻塞当前脚本执行
  // 这样既能尽早开始预加载，又不会影响应用的初始渲染
  Promise.resolve().then(() => {
    preloadCriticalPages();
  });
}

createRoot(document.getElementById('root')!).render(
  <RouterProvider router={router} />
);
